import { computed } from 'vue'
import { getQueryPlan, getQueryImage } from '@/api/report.model'

export function useFilterDialogQuery({ props, plan, image, pageSize, pageIndex, tableData, total, loading, restoreSelection }) {
  const isPlanType = computed(() => props.title === '计划选择')

  const getData = () => {
    loading.value = true
    tableData.value = []
    if (isPlanType.value) {
      const { planName, designerIds, mediaIds, adAccountIdList } = plan.value
      return getQueryPlan({
        planName,
        designerIds,
        mediaIds,
        adAccountIdList,
        pageSize: pageSize.value,
        pageIndex: pageIndex.value
      })
        .then((data) => {
          tableData.value = data.list && data.list.length ? data.list : []
          total.value = data.page_info && data.page_info.total_number
          restoreSelection()
        })
        .finally(() => {
          loading.value = false
        })
    }
    const { imageName, designerIds, gameGroupIds, gameIds } = image.value
    return getQueryImage({
      imageName,
      designerIds,
      gameGroupIds,
      gameIds,
      pageSize: pageSize.value,
      pageIndex: pageIndex.value
    })
      .then((data) => {
        tableData.value = data.list && data.list.length ? data.list : []
        total.value = data.page_info && data.page_info.total_number
        restoreSelection()
      })
      .finally(() => {
        loading.value = false
      })
  }

  const search = () => {
    pageIndex.value = 1
    getData()
  }

  const changePageIndex = (index) => {
    pageIndex.value = index
    getData()
  }

  const changePageSize = (size) => {
    pageSize.value = size
    search()
  }

  const handleChange = () => {
    search()
  }

  return {
    getData,
    search,
    changePageIndex,
    changePageSize,
    handleChange
  }
}
